import { SORT_OPTIONS } from "../APICalls/buildGetPurchasesUrl";
import SortOption from "../Interfaces/SortOption";

const SortOptionMapper = {
  SaleDateDescending: "Sale Date (New)",
  SaleDateAscending: "Sale Date (Old)",
  RegistrationNumberAscending: "Registration Number",
  DescriptionAscending: "Make/Model (A/Z)",
};

const processUISortOptions = (sortOptions: SortOption[]) =>
  sortOptions
    .filter(
      (option) =>
        ![
          SORT_OPTIONS.RegistrationNumberDescending,
          SORT_OPTIONS.DescriptionDescending,
        ].includes(option.key as SORT_OPTIONS)
    )
    .map((option) => ({
      key: option.key,
      label: SortOptionMapper[option.key],
    }));

export default processUISortOptions;
